import React from "react";

const ListDiscounts = () => {
  return <div>DisCount List</div>;
};

export default React.memo(ListDiscounts);
